<template>
  <div>

    <el-popover placement="bottom" trigger="manual" :value="showpopover" content="this is content">
      <div id="popup" v-if="activated">
        <popupmodify ref="popupmodify" id="popupmodify" :datafromsingleclct="datafromsingleclct"
          :tableleveldata="pos.data"></popupmodify>
        <aggregate @dataready="dataready" @cilckfromsigleclct="cilckfromsigleclct"></aggregate>
      </div>

      <el-button @click="toactivate" type="text" v-bind:style="{
        position: 'fixed',
        top: pos.y - 40 + 'px',
        left: pos.x + 'px',
        display: display//pos.selection? 'block' : 'none',
      }" slot="reference">
        &#128269;
      </el-button>
      <!-- 放大镜 -->
    </el-popover>
  </div>
</template>
<script>
import aggregate from "@/components/news/aggregate.vue";
import popupmodify from "./popup_modify";
export default {
  props: ["pos"],
  components: { aggregate, popupmodify },
  mounted() {
    //如果按esc，那么退出
    this.$nextTick(function () {
      window.addEventListener("keyup", e => {
        if (e.keyCode === 27) {
          this.showpopover = false
        }
      })
    })
  },
  data() {
    return {
      datafromsingleclct: { data: {}, field: {} },
      dataisready: false,
      showpopover: false,
      activated: false
    }
  },
  watch: {
    pos: {
      handler: function (newval, oldVal) {
        this.showpopover = false
      },
      deep: true,
    }
  },
  computed: {

    display() {
      //如果是superadmin一直保证check显示
      if (this.pos.selection || this.$store.state.roles.includes('superadmin')) {
        return "block"
      }
      else {
        return "none"
      }

    }
  },
  methods: {
    cilckfromsigleclct(singledata) {
      this.datafromsingleclct = singledata;
      this.$refs.popupmodify.cilckfromsigleclct(singledata)
    },


    //dataready信号，aggregate需要在数据加载以后显示，这样才能自动调整大小，否则会有变形
    dataready() {
      this.dataisready = true
      this.showpopover = true
    },
    toactivate() {
      // if(this.dataisready){

      // }
      // this.showpopover=true
      if (this.pos.selection || this.activated == false) {
        this.activated = false
        let self = this
        setTimeout(function () { self.activated = true }, 50)
      }
      else {
        this.showpopover = true
      }
    }
  }
}
</script>

<style>
#popupmodify {
  position: sticky;
  top: 0;
  z-index: 100;
}

#popup {
  /* position: fixed;
  background-color: rgb(236, 229, 230); */
  /* width: fit-content; */
  max-width: 60vw;
  max-height: 70vh;
  overflow: auto;
}
</style> 


// WEBPACK FOOTER //
// src/components/presentation/table/popup.vue